(function () {
  const SUNSCREEN_IDS = [15457129300122, 15457130938522]; // Everyday + Water Safe
  const SHIP_CODE = 'DUOSHIP-7K2Q';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  let syncing = null;

  function sync() {
    if (syncing) return syncing;
    syncing = (async () => {
      try {
        const cart = await (await nativeFetch(root + 'cart.js')).json();
        const count = cart.items
          .filter(i => SUNSCREEN_IDS.includes(i.product_id))
          .reduce((s, i) => s + i.quantity, 0);
        const qualifies = count >= 2;
        const current = (cart.discount_codes || []).map(d => d.code);
        const hasCode = current.some(c => c.toUpperCase() === SHIP_CODE);
        if (qualifies !== hasCode) {
          const codes = qualifies
            ? [...current, SHIP_CODE]
            : current.filter(c => c.toUpperCase() !== SHIP_CODE);
          await nativeFetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        }
      } catch (e) { console.warn('Sunscreen free shipping sync failed', e); }
      syncing = null;
    })();
    return syncing;
  }

  // Re-check whenever the theme adds/changes/removes cart items
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(() => sync());
    return p;
  };

  // Check on page load, and make sure it's applied right before checkout
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('submit', async (e) => {
    const btn = e.submitter;
    if (!btn || btn.name !== 'checkout' || e.target.dataset.fsSynced) return;
    e.preventDefault();
    await sync();
    e.target.dataset.fsSynced = '1';
    e.target.requestSubmit(btn);
  });
})();